// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3ig0b","cell":"ColumnAccessor_cell__28EtM","firstCellAccent":"ColumnAccessor_firstCellAccent__2mjSB"};